<template>
  <v-card class="elevation-12">
    <slot name="title"></slot>

    <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="invoicesTotal"
        :options.sync="options"
        :loading="loading"
        :dense="settings.dense"
        :hide-default-footer="true"
        item-key="id"
    >
      <template v-slot:no-data> По Вашему запросу данных не найдено</template>

      <template v-slot:top="scope">
        <v-sheet color="grey lighten-3" class="px-4 pt-4 pb-3" tile>
          <h3 class="transition-swing font-weight-medium">Фильтрация</h3>

          <v-responsive>
            <v-row>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <DateInput
                    v-model="filters.start"
                    label="Дата счёт-фактуры начало"
                    @change="onStartChanged"
                    :disabled="startDisabled"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <DateInput
                    v-model="filters.end"
                    label="Дата счёт-фактуры конец"
                    @change="onEndChanged"
                    :disabled="endDisabled"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.branch"
                    :items="$store.getters.useBranches"
                    item-value="id"
                    :item-text="item => {return `${item.name} (${item.ownerName})`}"
                    :clearable="true"
                    label="Магазин"
                    :disabled="branchDisabled"
                    @change="onBranchChanged"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete
                    v-model="filters.isExecutorApproved"
                    :items="isExecutorApprovedOptions"
                    label="Подтверждён поставщиком"
                    @change="onIsExecutorApprovedChanged"
                    :disabled="isExecutorApprovedDisabled"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete
                    v-model="filters.isCustomerApproved"
                    :items="isCustomerApprovedOptions"
                    label="Подтверждён заказчиком"
                    @change="onIsCustomerApprovedChanged"
                    :disabled="isCustomerApprovedDisabled"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete
                    v-model="filters.isDeclined"
                    :items="isDeclinedOptions"
                    label="Отклонён заказчиком"
                    @change="onIsDeclinedChanged"
                    :disabled="isDeclinedDisabled"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-text-field
                    v-model="filters.search"
                    label="Поиск"
                    append-icon="magnify"
                    single-line
                    hide-details
                    light
                    @input="onSearchInput"
                    :disabled="searchDisabled"
                    :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
                <v-autocomplete v-model="filters.status"
                                :items="statusOptions"
                                :clearable="true"
                                label="Статус"
                                :disabled="false"
                                @change="onStatusChanged"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
                <v-autocomplete v-model="filters.statuses" :items="statusOptions" :clearable="true" label="Статусы" :disabled="false" @change="onStatusesChanged" :dense="true" multiple>
                  <template v-slot:selection="{item}">
                    <v-chip small="small" :class="elementClass(item)" close @click:close="removeSelectedStatus(item)">{{ item.text }}</v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-responsive>
        </v-sheet>
        <v-divider/>

        <v-card-actions>
          <template>
            <v-data-footer
                :pagination="scope.pagination"
                :options="scope.options"
                :items-per-page-options="itemsPerPageOptions"
                items-per-page-text="Показать по"
                @update:options="scope.updateOptions"
            />
          </template>

          <v-spacer/>

          <v-badge bordered overlap left>
            <template v-slot:badge>
              {{ signableItemsCount }}
            </template>

            <v-btn
                icon
                color="primary"
                @click="onSignAllClicked"
                :disabled="!$store.getters.isCertificateLoaded"
            >
              <v-icon>fa-pen</v-icon>
            </v-btn>
          </v-badge>
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  icon
                  @click="onAllExcelWithItemsClicked"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="dialog"
                  :loading="dialog"
              >
                <v-icon color="primary" dark>fa-file-excel</v-icon>
              </v-btn>
              <v-dialog v-model="dialog" hide-overlay persistent fullscreen>
                <v-card color="primary" dark>
                  <div class="container">
                    <div>
                      <v-progress-circular
                          :rotate="360"
                          :value="dialogValue"
                          size="250"
                          width="15"
                          color="white"
                      >
                        <span style="font-size: 3rem">
                          {{ dialogValue }}
                        </span>
                      </v-progress-circular>
                    </div>
                    <div>
                      <v-card-text>
                        <h3 class="font-weight-medium text-center">
                          Слишком много счёт-фактур требуется время для загрузки
                        </h3>
                      </v-card-text>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </template>
            <span>Выгрузка счёт-фактуры с товарами в Excel</span>
          </v-tooltip>
          <v-btn color="primary" icon @click="onSettingsIconClicked">
            <v-icon>fa-cog</v-icon>
          </v-btn>
          <v-btn color="primary" icon text @click="onReloadClicked">
            <v-icon>fa-sync</v-icon>
          </v-btn>
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{on, attrs}">
              <div class="text-center">
                <v-btn color="primary" icon @click="onAllExcelClicked" v-bind="attrs" v-on="on" :disabled="dialog"
                       :loading="dialog">
                  <v-icon>fa-file-excel</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Выгрузка cчёт-фактуры в Excel</span>
          </v-tooltip>

        </v-card-actions>
      </template>
      <template v-slot:body.append>
        <tr v-if="items.length">
          <td v-for="header in headers" :key="header.value">
            <h3 v-if="header.value === 'status'">Итого</h3>
            <h3 v-else-if="header.value === 'total'">
              {{ sumTotal | decimalMinorCeilTwoDigit }}
            </h3>
          </td>
        </tr>
      </template>

      <template v-slot:item.status="{item}">
        <InvoiceStatusComponent :status="item.status" :id="item.id" :number="item.number"/>
      </template>
      <template v-slot:item.deliveryAddress="{ item }">
        <template v-if="item.shipment">
          {{ item.shipment.deliveryAddress }}
        </template>
      </template>
      <template v-slot:item.date="{ item }">
        {{ item.date.format("DD.MM.YYYY") }}
      </template>
      <template v-slot:item.createdOn="{ item }">
        {{ item.createdOn.format("DD.MM.YYYY HH:mm:ss") }}
      </template>
      <template v-slot:item.total="{ item }">
        {{ item.total | decimalMinorCeilTwoDigit }}
      </template>
      <template v-slot:item.shipmentNumber="{ item }">
        <ShipmentStatus v-if="item.shipment" :status="item.shipment.status" :number="item.shipment.number" :id="item.shipment.id"/>
      </template>
      <template v-slot:item.contrAgent="{ item }">
        <template v-if="item.customerDetails.inn === $store.getters.companyInn">
          {{ item.executorDetails.name }}
        </template>
        <template v-else>
          {{ item.customerDetails.name }}
        </template>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
            icon
            color="primary"
            x-small
            v-if="isSignable(item)"
            :disabled="!$store.getters.isCertificateLoaded"
            @click="onSignInvoiceClicked(item)"
        >
          <v-icon>fa-pen</v-icon>
        </v-btn>

        <v-btn
            icon
            color="primary"
            class="ml-1"
            x-small
            @click="onOpenPreview(item)"
        >
          <v-icon>fa-circle</v-icon>
        </v-btn>
        <v-btn
            icon
            color="primary"
            class="ml-1"
            x-small
            @click="onSingleExcelClicked(item)"
        >
          <v-icon>fa-file-excel</v-icon>
        </v-btn>
        <v-btn
            icon
            color="primary"
            x-small
            class="ml-1"
            @click="onPrintClicked(item)"
        >
          <v-icon>fa-print</v-icon>
        </v-btn>
        <v-btn
            icon
            color="primary"
            x-small
            class="ml-1"
            :to="{ name: 'invoice-page', params: { id: item.id } }"
        >
          <v-icon>fa-eye</v-icon>
        </v-btn>
      </template>

      <template
          v-for="addHeader in addHeaders"
          v-slot:[`item.${addHeader.value}`]="scope"
      >
        <slot :name="addHeader.value" :slot-scope="scope"></slot>
      </template>
    </v-data-table>

    <v-dialog v-model="settingsDialog" persistent max-width="720px">
      <v-card>
        <v-card-title>
          <span class="headline">Настройка таблицы</span>
        </v-card-title>

        <v-card-text>
          <h3 class="transition-swing font-weight-medium">Интерфейс</h3>
          <v-sheet color="grey lighten-3">
            <v-responsive>
              <v-autocomplete
                  v-model="settings.dense"
                  :items="denseOptions"
                  :dense="true"
              />
            </v-responsive>
          </v-sheet>

          <h3 class="transition-swing font-weight-medium mt-2">
            Включить / выключить отображение колонок
          </h3>
          <v-sheet color="grey lighten-3" class="px-4 pt-4 pb-3" tile>
            <v-responsive>
              <v-switch
                  v-for="column in settings.columns"
                  v-model="column.display"
                  :key="column.value"
                  color="primary"
                  :label="column.text"
                  dense
                  class="ma-0 pa-0"
                  :hide-details="true"
              />
            </v-responsive>
          </v-sheet>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="
              saveSettings();
              settingsDialog = false;
            "
          >Закрыть
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preview.dialog" max-width="100%">
      <InvoicePreview :invoice="preview.invoice" v-if="preview.invoice">
        <template v-slot:top>
          <v-card-title>
            <v-spacer/>
            <v-btn @click="preview.dialog = false" dark text>Закрыть</v-btn>
          </v-card-title>
        </template>
      </InvoicePreview>
      <h3 class="text-center" v-else>Идет загрузка...</h3>
    </v-dialog>

    <v-snackbar v-model="isSignSuccess" top :timeout="5000" color="success"
    >Документ успешно подписан
    </v-snackbar
    >
    <v-snackbar
        v-model="isSignGetHashCodeFailed"
        top
        :timeout="5000"
        color="error"
    >Ошибка при получении хешкода
    </v-snackbar>
    <v-snackbar
        v-model="isSignGotInvalidHashCode"
        top
        :timeout="5000"
        color="error"
    >Получены неполные хешкоды для подписи
    </v-snackbar>

    <v-snackbar v-model="isSignEimzoFailed" top :timeout="5000" color="error"
    >Ошибка при подсании с E-imzo
    </v-snackbar
    >
    <v-snackbar
        v-model="isSignRoamingServiceProcessingFailed"
        top
        :timeout="5000"
        color="error"
    >Ошибка при обработке на сервере ГНК
    </v-snackbar>
    <v-snackbar
        v-model="isSignRoamingSignatureValidationFailed"
        top
        :timeout="5000"
        color="error"
    >Ошибка в подписи для ГНК
    </v-snackbar>
    <v-snackbar
        v-model="isSignSignatureValidationFailed"
        top
        :timeout="5000"
        color="error"
    >Ошибка в подписи фактуры
    </v-snackbar>
    <v-snackbar
        v-model="isSignCreditLimitIsLowFailed"
        top
        :timeout="5000"
        color="error"
    >Ваш кредитный лимит исчерпан
    </v-snackbar>
    <v-snackbar
        v-model="isSignBalanceLowFailed"
        top
        :timeout="5000"
        color="error"
    >Недостаточно средств на счету для подписи
    </v-snackbar>
    <v-snackbar
        v-model="isSignUnknownErrorFailed"
        top
        :timeout="5000"
        color="error"
    >Ошибка при подписании, пожалуйста обратитесь за технической помощью
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from "underscore";
import DateInput from "@/components/Input/DateInput";
import {
  SIGN_INVOICE_BY_CUSTOMER,
  SIGN_INVOICE_BY_EXECUTOR,
} from "@/store/modules/sign/actions";
import InvoiceStatusComponent from "@/components/Status/InvoiceStatus"
import * as BusEvents from "@/eventbus/events";
import InvoicePreview from "@/components/main/invoice/InvoicePreview";
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
} from "@/store/modules/layout/actions";
import InvoiceService from "@/services/invoice.service";
import * as InvoiceStatus from "@/enum/InvoiceStatus"
import {
  GetStatusVariant
} from "@/enum/InvoiceStatus";
import ShipmentStatus from "@/components/Status/ShipmentStatus";
import Mapper from "@/helpers/mappers"

export default {
  name: "InvoiceDataTable",
  components: {
    ShipmentStatus,
    InvoicePreview,
    DateInput,
    InvoiceStatusComponent
  },

  props: {
    invoices: {
      type: Array,
      default: () => {
        return [];
      },
    },
    invoicesTotal: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    startDisabled: {
      type: Boolean,
      default: false,
    },
    endDisabled: {
      type: Boolean,
      default: false,
    },
    branchDisabled: {
      type: Boolean,
      default: false,
    },
    isExecutorApprovedDisabled: {
      type: Boolean,
      default: false,
    },
    isCustomerApprovedDisabled: {
      type: Boolean,
      default: false,
    },
    isDeclinedDisabled: {
      type: Boolean,
      default: false,
    },
    searchDisabled: {
      type: Boolean,
      default: false,
    },

    dialogValue: {
      typeNumber: Number,
      default: 0,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    // defaultValue
    startDefaultValue: {
      type: Object,
      default: null,
    },
    endDefaultValue: {
      type: Object,
      default: null,
    },
    branchDefaultValue: {
      type: Number,
      default: null,
    },
    isExecutorApprovedDefaultValue: {
      type: Boolean,
      default: null,
    },
    isCustomerApprovedDefaultValue: {
      type: Boolean,
      default: null,
    },
    isDeclineDefaultValue: {
      type: Boolean,
      default: null,
    },
    searchDefaultValue: {
      type: String,
      default: null,
    },
    pageDefaultValue: {
      type: Number,
      default: null,
    },
    limitDefaultValue: {
      type: Number,
      default: null,
    },
    sortDefaultValue: {
      type: String,
      default: null,
    },
    statusDefaultValue: {
      type: Number,
      default: null
    },
    descDefaultValue: {
      type: Boolean,
      default: null,
    },


    addHeaders: {
      type: Array,
      default() {
        return [];
      },
    },
    removeHeaders: {
      type: Array,
      default() {
        return [];
      },
    },

    previewDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      settingsDialog: false,
      settings: {
        dense: true,
        columns: [],
      },
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ["createdOn"],
        sortDesc: [true],
      },
      filters: {
        start: null,
        end: null,
        branch: null,
        search: null,

        isCustomerApproved: null,
        isExecutorApproved: null,
        isDeclined: null,
        status: null,
        statuses: []
      },

      isExecutorApprovedOptions: [
        {text: "Да", value: true},
        {text: "Нет", value: false},
        {text: "Неважно", value: null},
      ],
      isCustomerApprovedOptions: [
        {text: "Да", value: true},
        {text: "Нет", value: false},
        {text: "Неважно", value: null},
      ],
      isDeclinedOptions: [
        {text: "Да", value: true},
        {text: "Нет", value: false},
        {text: "Неважно", value: null},
      ],
      denseOptions: [
        {text: "Компактный", value: true},
        {text: "Обычный", value: false},
      ],
      statusOptions: [
        {text: InvoiceStatus.GetStatusText(InvoiceStatus.InvoiceCreated), value: InvoiceStatus.InvoiceCreated},
        {text: InvoiceStatus.GetStatusText(InvoiceStatus.InvoiceSend), value: InvoiceStatus.InvoiceSend},
        {text: InvoiceStatus.GetStatusText(InvoiceStatus.InvoiceDeleted), value: InvoiceStatus.InvoiceDeleted},
        {text: InvoiceStatus.GetStatusText(InvoiceStatus.InvoiceCanceled), value: InvoiceStatus.InvoiceCanceled},
        {text: InvoiceStatus.GetStatusText(InvoiceStatus.CustomerApproved), value: InvoiceStatus.CustomerApproved},
        {text: InvoiceStatus.GetStatusText(InvoiceStatus.CustomerDeclined), value: InvoiceStatus.CustomerDeclined}
      ],
      columns: [
        {text: "№", value: "displayNumber", sortable: false},
        {text: "Статус", value: "status", sortable: false},
        {text: "Дата", value: "date", sortable: true},
        {text: "Сумма", value: "total", sortable: true},
        {text: "Пункт разгрузки", value: "deliveryAddress", sortable: true},
        {text: "Контрагент", value: "contrAgent", sortable: true},
        {text: "Создана", value: "createdOn", sortable: true},
        {text: "Номер поставки", value: "shipmentNumber", sortable: true},
        {text: "Действия", value: "actions", sortable: false, align: "right"},
      ],

      itemsPerPageOptions: [50, 100, 200],

      // alerts
      isSignSuccess: false,
      isSignGetHashCodeFailed: false,
      isSignGotInvalidHashCode: false,
      isSignEimzoFailed: false,
      isSignRoamingServiceProcessingFailed: false,
      isSignRoamingSignatureValidationFailed: false,
      isSignSignatureValidationFailed: false,
      isSignCreditLimitIsLowFailed: false,
      isSignBalanceLowFailed: false,
      isSignUnknownErrorFailed: false,

      // queue sign
      signQueue: [],

      // preview
      preview: {
        dialog: false,
        invoice: null,
      },
    };
  },

  computed: {
    headers() {
      let displayColumns = _.filter(this.settings.columns, (column) => {
        return column.display;
      });

      let headers = _.map(displayColumns, (dc) => {
        return _.find(this.columns, (c) => {
          return c.value === dc.value;
        });
      });

      _.each(this.removeHeaders, (rh) => {
        headers = _.filter(headers, (dc) => {
          return dc.value !== rh;
        });
      });

      _.each(this.addHeaders, (ch) => {
        headers.push(ch);
      });

      return headers;
    },
    sumTotal() {
      let sumTotal = 0;
      _.each(this.invoices, (i) => {
        sumTotal += i.total;
      });

      return sumTotal;
    },
    items() {
      let number = 1;
      let skip = this.skip;

      return _.map(this.invoices, (m) => {
        m.displayNumber = skip + number++;
        return m;
      });
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage;
    },

    signableItemsCount() {
      return _.filter(this.items, (invoice) => {
        return this.isSignable(invoice);
      }).length;
    },
  },

  methods: {
    elementClass(item){
      return GetStatusVariant(item.value)
    },
    removeSelectedStatus(item){
      const index = this.filters.statuses.indexOf(item.value)

      if(index !== null)
        this.filters.statuses.splice(index, 1)

      this.updateItems()
    },
    // UI events
    onBranchChanged() {
      this.updateItems();
    },
    onStartChanged() {
      this.updateItems();
    },
    onEndChanged() {
      this.updateItems();
    },
    onIsExecutorApprovedChanged() {
      this.updateItems();
    },
    onIsCustomerApprovedChanged() {
      this.updateItems();
    },
    onIsDeclinedChanged() {
      this.updateItems();
    },
    onStatusChanged() {
      this.updateItems()
    },
    onStatusesChanged(){
      this.updateItems()
    },
    onReloadClicked() {
      this.updateItems();
    },
    onSettingsIconClicked() {
      this.settingsDialog = true;
    },
    onPrintClicked(invoice) {
      this.$emit("print", invoice.id);
    },
    onSingleExcelClicked(invoice) {
      this.$emit("excel-single", invoice.id);
    },
    onAllExcelWithItemsClicked() {
      this.$emit("excel-all-items", this.options, this.filters);
    },
    onOpenPreview(invoice) {
      this.$store.dispatch(LAYOUT_LOADING_START);

      InvoiceService.getInfo(invoice.id)
          .then((response) => {
            this.preview.invoice = Mapper.mapInvoiceInfo(response.data)

            this.preview.dialog = true;
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
    onAllExcelClicked() {
      this.$emit("excel-all", this.options, this.filters);
    },
    onSignAllClicked() {
      _.each(this.items, (invoice) => {
        if (this.isSignable(invoice)) {
          const isInvoiceInQueue = _.find(
              this.signQueue,
              (signQueueInvoice) => {
                return signQueueInvoice.id === invoice.id;
              }
          );
          if (!isInvoiceInQueue) this.signQueue.push(invoice);
        }
      });
      this.processSignQueue();
    },
    onSignInvoiceClicked(invoice) {
      this.signQueue.push(invoice);
      this.processSignQueue();
    },
    onSearchInput: _.debounce(function () {
      if (this.options.page === 1) {
        this.updateItems();
      } else {
        this.options.page = 1;
      }
    }, 1000),

    // methods
    updateItems() {
      this.$emit("update", this.options, this.filters);
    },
    saveSettings() {
      localStorage.invoicesTableSettings = JSON.stringify(this.settings);
    },
    loadSettings() {
      let invoicesTableSettingsStr = localStorage.invoicesTableSettings;
      if (typeof invoicesTableSettingsStr === "string") {
        let invoicesTableSettings = JSON.parse(invoicesTableSettingsStr);

        if (typeof invoicesTableSettings.dense === "boolean")
          this.settings.dense = invoicesTableSettings.dense;

        if (typeof invoicesTableSettings.columns === "object") {
          this.settings.columns = _.map(this.columns, (column) => {
            let invoicesTableSettingsColumn =
                _.find(invoicesTableSettings.columns, (c) => {
                  return c.value === column.value;
                }) || null;

            return {
              value: column.value,
              text: column.text,
              display: invoicesTableSettingsColumn
                  ? invoicesTableSettingsColumn.display
                  : true,
            };
          });
        }
      }
    },
    isWeCustomer(item) {
      return item.customerDetails.inn === this.$store.getters.companyInn;
    },
    isWeExecutor(item) {
      return item.executorDetails.inn === this.$store.getters.companyInn;
    },
    isSignable(invoice) {
      if (!invoice.isShipmentDeclined) {
        if (this.isWeCustomer(invoice))
          return !invoice.isCustomerApproved && invoice.isExecutorApproved;

        if (this.isWeExecutor(invoice))
          return !invoice.isCustomerApproved && !invoice.isExecutorApproved;
      }
      return false;
    },
    signInvoice(invoice) {
      if (this.isWeExecutor(invoice))
        this.$store.dispatch(SIGN_INVOICE_BY_EXECUTOR, invoice.id);
      else if (this.isWeCustomer(invoice))
        this.$store.dispatch(SIGN_INVOICE_BY_CUSTOMER, invoice.id);
    },
    processSignQueue() {
      const invoice = this.signQueue.shift();
      if (invoice) {
        this.signInvoice(invoice);
        return true;
      }

      return false;
    },

    // bus events
    onSignSuccess() {
      this.isSignSuccess = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignBalanceLowFailed() {
      this.isSignBalanceLowFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignCreditLimitIsLowFailed() {
      this.isSignCreditLimitIsLowFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignSignatureValidationFailed() {
      this.isSignSignatureValidationFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignRoamingSignatureValidationFailed() {
      this.isSignRoamingSignatureValidationFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignRoamingServiceProcessingFailed() {
      this.isSignRoamingServiceProcessingFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignEimzoFailed() {
      this.isSignEimzoFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignGotInvalidHashCode() {
      this.isSignGotInvalidHashCode = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignGetHashCodeFailed() {
      this.isSignGetHashCodeFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
    onSignUnknownErrorFailed() {
      this.isSignUnknownErrorFailed = true;
      if (!this.processSignQueue()) this.updateItems();
    },
  },

  watch: {
    options: {
      handler() {
        this.updateItems();
      },
    },
  },

  created() {
    // init events
    this.$bus.$on(BusEvents.SignSuccess, this.onSignSuccess);
    this.$bus.$on(
        BusEvents.SignGotInvalidHashCode,
        this.onSignGotInvalidHashCode
    );
    this.$bus.$on(BusEvents.SignEimzoFailed, this.onSignEimzoFailed);
    this.$bus.$on(
        BusEvents.SignRoamingServiceProcessingFailed,
        this.onSignRoamingServiceProcessingFailed
    );
    this.$bus.$on(
        BusEvents.SignRoamingSignatureValidationFailed,
        this.onSignRoamingSignatureValidationFailed
    );
    this.$bus.$on(
        BusEvents.SignSignatureValidationFailed,
        this.onSignSignatureValidationFailed
    );
    this.$bus.$on(
        BusEvents.SignCreditLimitIsLowFailed,
        this.onSignCreditLimitIsLowFailed
    );
    this.$bus.$on(BusEvents.SignBalanceLowFailed, this.onSignBalanceLowFailed);
    this.$bus.$on(
        BusEvents.SignUnknownErrorFailed,
        this.onSignUnknownErrorFailed
    );
    this.$bus.$on(
        BusEvents.SignGetHashCodeFailed,
        this.onSignGetHashCodeFailed
    );

    // init default values
    if (typeof this.isDeclineDefaultValue === "boolean")
      this.filters.isDeclined = this.isDeclineDefaultValue;

    if (typeof this.isCustomerApprovedDefaultValue === "boolean")
      this.filters.isCustomerApproved = this.isCustomerApprovedDefaultValue;

    if (typeof this.isExecutorApprovedDefaultValue === "boolean")
      this.filters.isExecutorApproved = this.isExecutorApprovedDefaultValue;

    if (this.startDefaultValue) this.filters.start = this.startDefaultValue;

    if (this.endDefaultValue) this.filters.end = this.endDefaultValue;

    if (typeof this.searchDefaultValue === "string")
      this.filters.search = this.searchDefaultValue;

    if (typeof this.branchDefaultValue === "number")
      this.filters.branch = this.branchDefaultValue;

    if (typeof this.limitDefaultValue === "number")
      if (
          _.find(this.itemsPerPageOptions, (option) => {
            return option === this.limitDefaultValue;
          })
      )
        this.options.itemsPerPage = this.limitDefaultValue;

    if (typeof this.pageDefaultValue === "number")
      this.options.page = this.pageDefaultValue;

    if (typeof (this.statusDefaultValue) === 'number')
      this.filters.status = this.statusDefaultValue

    if (typeof this.descDefaultValue === "boolean")
      this.options.sortDesc = [this.descDefaultValue];

    if (typeof this.sortDefaultValue === "string")
      if (
          _.find(this.columns, (column) => {
            return column.value === this.sortDefaultValue && column.sortable;
          })
      )
        this.options.sortBy = [this.sortDefaultValue];

    // init setting columns
    this.settings.columns = _.map(this.columns, (column) => {
      return {
        value: column.value,
        text: column.text,
        display: true,
      };
    });

    this.loadSettings();
  },
  beforeDestroy() {
    this.$bus.$off(BusEvents.SignSuccess, this.onSignSuccess);
    this.$bus.$off(
        BusEvents.SignGotInvalidHashCode,
        this.onSignGotInvalidHashCode
    );
    this.$bus.$off(BusEvents.SignEimzoFailed, this.onSignEimzoFailed);
    this.$bus.$off(
        BusEvents.SignRoamingServiceProcessingFailed,
        this.onSignRoamingServiceProcessingFailed
    );
    this.$bus.$off(
        BusEvents.SignRoamingSignatureValidationFailed,
        this.onSignRoamingSignatureValidationFailed
    );
    this.$bus.$off(
        BusEvents.SignSignatureValidationFailed,
        this.onSignSignatureValidationFailed
    );
    this.$bus.$off(
        BusEvents.SignCreditLimitIsLowFailed,
        this.onSignCreditLimitIsLowFailed
    );
    this.$bus.$off(BusEvents.SignBalanceLowFailed, this.onSignBalanceLowFailed);
    this.$bus.$off(
        BusEvents.SignUnknownErrorFailed,
        this.onSignUnknownErrorFailed
    );
    this.$bus.$off(
        BusEvents.SignGetHashCodeFailed,
        this.onSignGetHashCodeFailed
    );
  },
};
</script>

<style scoped>
.container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.v-data-footer {
  justify-content: flex-start;
  -webkit-box-align: start;

  border-top: none !important;
}

.status {
  min-width: 100px;
  text-align: center;
  display: block;
}
</style>